module.exports = __webpack_public_path__ + "assets/img/4e5fd0de3ed96eeb74763be2f70b45bf.svg";